// CSS pixels, shared by native paint expressions and exact pointer hit testing.
// Pins replace the dots at PIN_ZOOM in full size (Max, 23.10.): no growth phase, the tip sits on the site from the start.
export const PIN_ZOOM=14,PIN_FULL_ZOOM=PIN_ZOOM,PIN_PREFETCH_ZOOM=13;
// Dots (R94, Max 24.10.): small far out (the R90 variant a); from z12 they grow towards the pin so the swap at PIN_ZOOM jumps less.
export const RADIUS_STOPS=[[0,.7],[4,1],[7,1.6],[11,3.4],[12,4.2],[14,10]];
export const DOT_RADIUS=['interpolate',['linear'],['zoom'],...RADIUS_STOPS.flat()];
export const PIN_GROWTH=1;
// The one dot layer: the GPU custom layer, or the circle layer with ?dots=circle (dot-variants.mjs).
export const DOT_LAYER_IDS=['site-dots'];
// Value of [[zoom,value],…] stops at a zoom, linear and clamped like a MapLibre interpolate expression.
export function stopsAt(stops,zoom){
  for(let i=1;i<stops.length;i++)if(zoom<stops[i][0]){
    const [a,x]=stops[i-1],[b,y]=stops[i];return x+(y-x)*Math.max(0,(zoom-a)/(b-a));
  }
  return stops.at(-1)[1];
}
export const dotRadius=zoom=>stopsAt(RADIUS_STOPS,zoom);
export const pinGrowth=()=>1;
export const pinTranslation=()=>0;

// Sites per message when the decoded catalog goes from the map worker to the page, dots/diff entries per slice of a big source update.
export const CATALOG_SLICE=500,DOT_SLICE=8000;
